/**
 * Handle color string
 */
export enum Colors {
  NONE = "#000000",
  RED = "#FF0000",
  BLUE = "#0000FF",
  GREEN = "#00FF00",
}
